import { useMessageStore } from "../../store";

export const asyncActionWrapper = async (
  action: () => Promise<void>,
  successMsg: string,
  errorMsg: string
) => {
  try {
    await action();
    useMessageStore.getState().addSuccess(successMsg);
  } catch (error) {
    useMessageStore.getState().addError(
      `${errorMsg}: ${error instanceof Error ? error.message : "Unknown error"}`
    );
  }
};
